import {Button, Stack, styled} from '@mui/material';

const FilterHeader = styled(Stack)`
	width: 100%;
	padding: 0px 0px;
	box-shadow: 0px 4px 22px 0px #33333314;

	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	background-color: ${({theme}) => theme.colors.gray['10Percent']};
`;

const StyledButton = styled(Button)`
	padding: 20px 32px;
	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 12px 16px;
	}
	border-radius: 0;
`;

export {FilterHeader, StyledButton};
